import { useQuery } from "@tanstack/react-query";
import { db } from "@/modules/shared/lib/db-client";
import { useAuth } from "./useAuth";
import { log } from "@/modules/shared/lib/observability";

export function useUserRole() {
  const { user } = useAuth();

  const { data, isLoading } = useQuery({
    queryKey: ["user-role", user?.id],
    queryFn: async () => {
      if (!user?.id) return null;

      // Check user_roles table for admin role
      const { data: roles, error } = await db
        .from("user_roles")
        .select("role")
        .eq("user_id", user.id);

      if (error) {
        log.error("Error fetching user roles", {}, error);
        return null;
      }

      // Also check professionals for role
      const { data: teamMember } = await db
        .from("professionals")
        .select("role")
        .eq("professional_type", "operacional")
        .eq("user_id", user.id)
        .maybeSingle();

      return {
        userRoles: roles?.map(r => r.role) || [],
        teamMemberRole: teamMember?.role || null,
        isAdmin: roles?.some(r => r.role === "admin") || teamMember?.role === "admin",
      };
    },
    enabled: !!user?.id,
  });

  return {
    isAdmin: data?.isAdmin || false,
    userRoles: data?.userRoles || [],
    teamMemberRole: data?.teamMemberRole,
    isLoading,
  };
}
